import React from "react";
import { CalendarOutlined } from "@ant-design/icons";
import { rupeesWhole } from "../Insights/format";

export const money = (value) => rupeesWhole(value);

export const riderCount = (count) => `${count} rider${count === 1 ? "" : "s"}`;

export const toAdminTone = (value) => (value > 0 ? "stl-owed" : value < 0 ? "stl-paid" : "stl-zero");

export const Money = ({ value }) => <span className={value ? undefined : "stl-zero"}>{money(value)}</span>;

export const NumberCell = ({ value, onChange, label }) => (
  <input
    className="stl-input stl-input--sm stl-input--num stl-cell-input"
    type="number"
    min="0"
    step="1"
    placeholder="0"
    aria-label={label}
    value={value}
    onChange={(e) => onChange(e.target.value)}
  />
);

export const Empty = ({ title, text, children }) => (
  <div className="stl-empty">
    <span className="stl-empty__icon">
      <CalendarOutlined />
    </span>
    <span className="stl-empty__title">{title}</span>
    <span className="stl-empty__text">{text}</span>
    {children}
  </div>
);

export const RiderCell = ({ id, name }) => (
  <div className="stl-rider">
    <a className="stl-rider__name" href={`/deliboy/${id}`}>
      {name || "—"}
    </a>
    <span className="stl-rider__id">#{id}</span>
  </div>
);
